import { gql } from '@apollo/client';

import { useMutationCompat as useMutation } from '../../lib/apollo/mutationCompat';

const ADD_POLICY = gql`
  mutation ($policy: AddPolicyInput) {
    AddPolicyV2(policy: $policy)
  }
`;

const EDIT_POLICY = gql`
  mutation ($policy: EditPolicyInput) {
    EditPolicyV2(policy: $policy)
  }
`;

const REMOVE_POLICY = gql`
  mutation ($policy_id: String!) {
    RemovePolicyV2(policy_id: $policy_id)
  }
`;

const EDIT_MINIMUM_POLICY = gql`
  mutation ($policy: MinPolicyInput) {
    EditMinimumPolicy(policy: $policy) {
      result {
        id
      }
    }
  }
`;

const TEST_MINIMUM_POLICY = gql`
  mutation ($policy: MinPolicyInput) {
    TestMinimumPolicy(policy: $policy) {
      result {
        noncompliant_accounts
      }
    }
  }
`;

const REMOVE_MINIMUM_POLICY = gql`
  mutation {
    RemoveMinimumPolicy
  }
`;

export function usePolicyMutations () {

  const [add] = useMutation(ADD_POLICY,
    { refetchQueries: ['getPolicies'] },
  );

  const [edit] = useMutation(EDIT_POLICY,
    { refetchQueries: ['getPolicies', 'getDevicesPolicyAssignments', 'contextGetDevices'] },
  );

  const [remove] = useMutation(REMOVE_POLICY,
    { refetchQueries: ['getPolicies', 'getDevicesPolicyAssignments', 'contextGetDevices'] },
  );

  const [editMin] = useMutation(EDIT_MINIMUM_POLICY,
    { refetchQueries: ['getPolicies', 'getMinimumPolicy', 'getSystemMessages', 'contextGetDevices'] },
  );

  const [testMin] = useMutation(TEST_MINIMUM_POLICY,
    { refetchQueries: ['getPolicies', 'getDevicesPolicyAssignments', 'contextGetDevices'] },
  );

  const [removeMin] = useMutation(REMOVE_MINIMUM_POLICY,
    { refetchQueries: ['getPolicies', 'getDevicesPolicyAssignments', 'contextGetDevices'] },
  );

  return { add, edit, remove, editMin, testMin, removeMin};
}
